import { profileEmailSectionStyles } from './profile-email-section.styles';

type ProfileEmailAddressRowProps = {
  value: string;
  label: string;
  actionLabel?: string;
  onAction?: () => void;
};

export const ProfileEmailAddressRow = ({
  value,
  label,
  actionLabel,
  onAction,
}: ProfileEmailAddressRowProps) => (
  <div className={profileEmailSectionStyles.shell}>
    <input value={value} aria-label={label} disabled className={profileEmailSectionStyles.input} />
    {actionLabel && onAction ? (
      <button type="button" onClick={onAction} className={profileEmailSectionStyles.shellLink}>
        {actionLabel}
      </button>
    ) : null}
  </div>
);
